import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Handler from "../../Helpers/Components/Handler";
import { getCookie, reloadWindow, reloadWindowToPath } from "../../Helpers/Utils";
import moment from "moment";
import Profile from "../../Assets/images/user.png"
import Log from '../../Helpers/Components/Log'
import Modal from "../../Helpers/Components/Modal";
import Compressor from 'compressorjs';
import { toast } from "react-toastify";
import Select from 'react-select'
import { DropdownToggle, DropdownButton } from '../../Helpers/Components/Dropdown';
import { useAuth } from "../../Contexts/AuthenticateProvider"

const View = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [detail, setDetails] = useState({})
    const [proof, setProof] = useState()
    const [point, setPoint] = useState({ label: 0, value: 0 })
    const [totalDays, setTotalDays] = useState(0)
    const [pending_photo, setPendingPhoto] = useState([])
    const [pending, setPending] = useState(false)
    const [refund, setRefund] = useState(0)
    const [loading, setLoading] = useState(false)
    const { userDetails } = useAuth()
    const person = getCookie('person')
    const [vehicle, setVehicle] = useState({ open: false, carId: "", value: "", options: [] })
    const [status, setStatus] = useState({ open: false, status: "", options: [] })
    const [photo, setPhoto] = useState({ photo: "-", open: false, name: "-" })
    const [form, setForm] = useState(false)
    const [modal, showModal] = useState(false)
    const [pageNo, setPage] = useState(1)
    const setPageNo = (value) => setPage(value)
    const [count, setCount] = useState(10)
    const [next, setNext] = useState(false)
    const [logDetails, setLogDetails] = useState({})
    const [cancel, setCancel] = useState({ booking: "", remarks: "" })
    const getDetails = async () => {
        const response = await Handler({ method: 'get', url: `/booking/detail/${id}` })
        if (response?.success) {
            setDetails({ ...response?.data, ...(response?.data?.booking?.stageHistory?.length ? { stageHistory: response?.data?.booking?.stageHistory?.filter(element => element?.staffId)?.length ? response?.data?.booking?.stageHistory?.filter(element => element?.staffId) : [] } : {}) })
            const proof = response?.data?.booking?.proofCollected ? response?.data?.booking?.proofCollected : []
            const collected = []
            proof?.map((element) => {
                if (element === "dl") {
                    collected?.push("Driving License")
                } else if (element === "aadhaar") {
                    collected?.push("Aadhaar Card")
                } else if (element === "passport") {
                    collected?.push("Passport")
                } else if (element === "voter") {
                    collected?.push("Voter ID")
                } else if (element === "familyCard") {
                    collected?.push("Family Card")
                } else {
                    collected?.push(element)
                }
            })
            setProof(collected)
            if (response?.data?.booking?.status === "Ongoing" || response?.data?.booking?.status === "Cancelled") {
                setStatus((prev) => ({ ...prev, options: [{ label: "Booked", value: "Booked" }] }))
            } else if (response?.data?.booking?.status === "Pending" || response?.data?.booking?.status === "Completed") {
                setStatus((prev) => ({ ...prev, options: [{ label: "Booked", value: "Booked" }, { label: "Ongoing", value: "Ongoing" }] }))
            }
            // let diff = ((new Date(response?.data?.booking?.pickupDetails?.pickup).getTime() - new Date(response?.data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600;
            // if (Math.ceil(diff / 12) / 2 == 0.5) {
            //     setTotalDays(1);
            //     setPoint({ label: 0, value: 0 })
            // } else {
            //     setTotalDays(Math.floor(Math.ceil(diff / 12) / 2));
            //     if (Math.ceil(diff / 12) % 2 !== 0) {
            //         let to = new Date(response?.data?.booking?.pickupDetails?.pickup)
            //         to?.setHours(new Date(response?.data?.booking?.pickupDetails?.pickup)?.getHours() - 2)
            //         let diff1 = ((to?.getTime() - new Date(response?.data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600
            //         if (Math.ceil(diff1 / 12) % 2 !== 0) {
            //             setPoint({ label: 0.5, value: 0.5 })
            //         } else {
            //             setPoint({ label: 0, value: 0 })
            //         }
            //     } else {
            //         setPoint({ label: 0, value: 0 })
            //     }
            // }
            if (response?.data?.booking?.deliveryDetails?.delivery && response?.data?.booking?.pickupDetails?.pickup) {
                if (response?.data?.booking?.totalDays) {
                    const totalDays = Math.floor(response?.data?.booking?.totalDays)
                    const point = Math.round((response?.data?.booking?.totalDays % 1) * 10)
                    setTotalDays(totalDays);
                    setPoint({ label: point > 0 ? 0.5 : 0, value: point > 0 ? 0.5 : 0 })
                } else {
                    let diff = ((new Date(response?.data?.booking?.pickupDetails?.pickup).getTime() - new Date(response?.data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600;
                    if (Math.ceil(diff / 12) / 2 == 0.5) {
                        setTotalDays(1);
                        setPoint({ label: 0, value: 0 })
                    } else {
                        setTotalDays(Math.floor(Math.ceil(diff / 12) / 2));
                        if (Math.ceil(diff / 12) % 2 !== 0) {
                            let to = new Date(response?.data?.booking?.pickupDetails?.pickup)
                            to?.setHours(new Date(response?.data?.booking?.pickupDetails?.pickup)?.getHours() - 2)
                            let diff1 = ((to?.getTime() - new Date(response?.data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600
                            if (Math.ceil(diff1 / 12) % 2 !== 0) {
                                setPoint({ label: 0.5, value: 0.5 })
                            } else {
                                setPoint({ label: 0, value: 0 })
                            }
                        } else {
                            setPoint({ label: 0, value: 0 })
                        }
                    }
                }
            }
            let excess = ((Number(response?.data?.booking?.fastTag?.start || 0) - Number(response?.data?.booking?.fastTag?.end || 0)) >= 0) ? (Number(response?.data?.booking?.fastTag?.start || 0) - Number(response?.data?.booking?.fastTag?.end || 0)) : 0
            let refund = (
                (Number(response?.data?.booking?.securityDeposit || 0)) -
                    (
                        Number(response?.data?.booking?.excessCharges?.length ? response?.data?.booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0)
                        + (Number(response?.data?.booking?.excess?.fuelCharges || 0) + Number(response?.data?.booking?.excess?.kmCharges || 0) + Number(response?.data?.booking?.excess?.timeCharges || 0))
                        + excess
                    ) > 0 ? ((Number(response?.data?.booking?.securityDeposit || 0)) -
                        (
                            Number(response?.data?.booking?.excessCharges?.length ? response?.data?.booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0)
                            + (Number(response?.data?.booking?.excess?.fuelCharges || 0) + Number(response?.data?.booking?.excess?.kmCharges || 0) + Number(response?.data?.booking?.excess?.timeCharges || 0))
                            + excess
                        )) : 0
            )
            setRefund(refund + Number(response?.data?.booking?.refund?.offer || 0))
        } else {
            reloadWindowToPath(`/booking/1`)
        }
    }
    const normalizePendingPhotos = (pendingPhoto) => {
        try {
            if (!Array.isArray(pendingPhoto)) return [];
            if (
                pendingPhoto.length === 1 &&
                typeof pendingPhoto[0] === "string" &&
                pendingPhoto[0].trim().startsWith("[")
            ) {
                try {
                    const parsed = JSON.parse(pendingPhoto[0]);
                    return Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                    return [];
                }
            }
            return pendingPhoto;
        } catch (err) {
            return []
        }
    }
    const handlePendingPhotos = () => {
        setPendingPhoto(normalizePendingPhotos(detail?.booking?.pendingPhoto));
        setPending(true)
    }
    const changeCar = async () => {
        if (!vehicle?.carId) {
            toast.error("Car ID is required")
            return
        }
        setLoading(true)
        const response = await Handler({ method: 'patch', url: `/admin/changeVehicle/${id}`, data: { carId: vehicle?.carId || "" } })
        if (response?.success) {
            toast.success(response?.message)
            setTimeout(() => {
                setLoading(false)
                reloadWindow()
            }, 1500);
        } else {
            setLoading(false)
            toast.error(response?.message)
        }
    }
    const checkDelivery = async (booking) => {
        const date = new Date(new Date(booking?.deliveryDetails?.delivery)?.setHours(0, 0, 0))
        const today = new Date()
        if (today >= date) {
            navigate(`/booking/delivery/${booking?.bookingId}`)
        } else {
            toast.error("Delivery can't be made")
        }
    }
    const changeStatus = async () => {
        if (!status?.status) {
            toast.error("Status is required")
            return
        }
        setLoading(true)
        const response = await Handler({ method: 'patch', url: `/admin/changeStatus/${id}`, data: { status: status?.status || "" } })
        if (response?.success) {
            toast.success("Status changed")
            setTimeout(() => {
                setLoading(false)
                reloadWindow()
            }, 1500);
        } else {
            setLoading(false)
            toast.error(response?.message)
        }
    }
    const checkFileSize = async (file) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            setLoading(true)
            const response = await Handler({ method: 'patch', url: `/booking/details/form/photo/${id}`, data: { formPhoto: file }, headers: { 'Content-Type': 'multipart/form-data' } })
            if (response?.success) {
                toast.success("Form Photo uploaded")
                setTimeout(() => {
                    reloadWindow()
                    setLoading(false)
                }, 1500);
            } else {
                setLoading(false)
                toast.error(response?.message)
            }
        }
    };
    const compressImage = (file) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0]);
        }
    };
    const handleDownload = async () => {
        try {
            setLoading(true)
            const response = await fetch(detail?.booking?.formPhoto);
            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `Form-Photo:${id}`;
            link.click();
            URL.revokeObjectURL(link.href);
            setLoading(false)
        } catch (err) {
            setLoading(false)
            console.error("Error downloading image:", err);
        }
    };
    const carDetails = async () => {
        const car = await Handler({ method: 'get', url: `/admin/changeVehicle/car/${id}` })
        if (car?.success) {
            setVehicle((prev) => ({ ...prev, options: car?.data?.length ? car?.data?.map(element => { return { label: element?.carId, value: element?.id } }) : [] }))
        } else {
            setVehicle((prev) => ({ ...prev, options: [] }))
        }
    }
    const cancelBooking = async () => {
        if (!cancel?.remarks) {
            toast.error("Remarks is required")
        } else {
            setLoading(true)
            const response = await Handler({ method: "patch", url: `/booking/details/cancel/${cancel?.booking}`, data: { remarks: cancel?.remarks } })
            if (response?.success) {
                toast.success(response?.message)
                showModal(false)
                setTimeout(() => {
                    reloadWindow()
                    setLoading(false)
                }, 1500);
            } else {
                toast.error(response?.message)
                setLoading(false)
            }
        }
    }
    useEffect(() => {
        getDetails()
        if (person === "admin") {
            carDetails()
        } else {
            setVehicle((prev) => ({ ...prev, options: [] }))
        }
    }, [])
    const getProofLog = async () => {
        setLoading(true)
        const response = await Handler({ method: 'post', url: `/booking/proof/log/${id}?pageNo=${pageNo}&count=${count}`, data: {} })
        if (response?.success) {
            setNext(response?.data?.next)
            setLogDetails(response?.data?.current?.length ? response?.data?.current : {})
        } else {
            setNext(false)
        }
        setLoading(false)
    }
    useEffect(() => {
        getProofLog()
    }, [pageNo, count])
    return (
        <React.Fragment>
            <div className="view-fixed">
                <div className="row px-5">
                    <div className="text-center col-md-4 text-capitalize"><span className="topTitle">Created By : </span>{detail?.booking?.stageHistory?.length ? (detail?.booking?.stageHistory?.filter(element => element?.stage === "Booked")?.length ? (detail?.booking?.stageHistory?.filter(element => element?.stage === "Booked")[0]?.subadmin?.name || detail?.booking?.stageHistory?.filter(element => element?.stage === "Booked")[0]?.admin?.name) : "-") : "-"}</div>
                    <div className="text-center col-md-4"><span className="topTitle">Booking ID : </span>{id || "-"}</div>
                    <div className="text-center col-md-4"><span className="topTitle">Register Date : </span>{detail?.booking?.createdAt ? moment(new Date(detail?.booking?.createdAt))?.format('DD/MM/YYYY') : "-"}</div>
                </div>
                <div className="inside-back-arrow"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
            </div>
            <div className="text-center text-capitalize mt-4"><span className="topTitle">Booking Stage : </span>{detail?.booking?.verified ? "Verified" : detail?.booking?.status || "Initiated"}</div>
            {detail?.booking?.verifiedBy && detail?.booking?.verified ? <div className="text-center text-capitalize mt-2"><span className="topTitle">Verified By : </span>{detail?.booking?.verifiedBy}</div> : ""}
            {detail?.booking?.correction?.correction && !detail?.booking?.verified ? <div className="text-center text-capitalize mt-2"><span className="topTitle">Correction Given By : </span>{detail?.booking?.correctionBy}</div> : ""}
            {detail?.booking?.verificationRemarks && detail?.booking?.verified ? <div className="text-center text-capitalize mt-2"><span className="topTitle">Verification Remarks : </span>{detail?.booking?.verificationRemarks}</div> : ""}
            {detail?.booking?.correction?.correction && !detail?.booking?.verified ? <div className="text-center text-capitalize mt-2"><span className="topTitle">Correction Remarks : </span>{detail?.booking?.verificationRemarks}</div> : ""}
            <div className="my-3 justify-content-center align-items-center d-flex gap-3 flex-wrap">

                {
                    detail?.booking?.status !== "Completed" && detail?.booking?.status !== "Cancelled" ?
                        <a href={
                            detail?.booking?.status === "Booked" ? `/booking/update/${id}` :
                                detail?.booking?.status === "Ongoing" ? `/booking/delivery/${id}` :
                                    detail?.booking?.status === "Pending" ? `/booking/pending/${id}` : `/booking/update/${id}`
                        } className="btn btn-sm btn-theme"> Edit Booking</a>
                        : ""
                }
                {
                    person === "admin" ? (detail?.booking?.status === "" || detail?.booking?.status === "Completed" ? "" : <button className="btn btn-sm btn-theme" onClick={() => setVehicle((prev) => ({ ...prev, carId: "", value: "", open: true }))}>Change Car</button>) : ""
                }
                {
                    person === "admin" && !detail?.booking?.verified ? (detail?.booking?.status === "" || detail?.booking?.status === "Booked" ? "" : <button className="btn btn-sm btn-theme" onClick={() => setStatus((prev) => ({ ...prev, status: "", open: true }))}>Change Status</button>) : ""
                }
                {
                    (person === "admin" || userDetails?.id === "SA004" || userDetails?.id === "SA001") && detail?.booking?.status === "Completed" && !detail?.booking?.verified ? <button className="btn btn-success btn-sm" onClick={() => navigate(`/booking/verify/${id}`)}>Verify Booking</button> : ""
                }

                {
                    detail?.booking?.bookingId ?
                        detail?.booking?.status === "Cancelled" ? "" :
                            detail?.booking?.status === "Completed" ? <Link to={`/booking/invoice/${detail?.booking?.bookingId}`} className="btn btn-success btn-sm"> Generate Bill </Link> :
                                <>
                                    <DropdownToggle label={"Action"} className="dropdown-list-head">
                                        {
                                            detail?.booking?.status === "Ongoing" || detail?.booking?.status === "Pending" ?
                                                <DropdownButton onClick={() => navigate(`/booking/close/${detail?.booking?.bookingId}`)} className="list-btns list-success-btn" label="Pickup" />
                                                : (detail?.booking?.status === "Booked" && detail?.booking?.carStatus) ?
                                                    <DropdownButton className="list-btns list-success-btn" label="Delivery" onClick={() => { checkDelivery(detail?.booking) }} /> :
                                                    !detail?.booking?.status ? <DropdownButton className="list-btns list-success-btn" label="Book" onClick={() => navigate(`/booking/update/${detail?.booking?.bookingId}`)} /> : ""
                                        }
                                        {
                                            (detail?.booking?.status === "Booked") ?
                                                <DropdownButton label="Cancel" className="list-btns list-danger-btn" onClick={() => { setCancel({ booking: detail?.booking?.bookingId, remarks: "" }); showModal(true) }} />
                                                : detail?.booking?.status === "Ongoing" ?
                                                    <DropdownButton label="Pending" className="list-btns list-danger-btn" onClick={() => navigate(`/booking/pending/${detail?.booking?.bookingId}`)} />
                                                    : ""
                                        }
                                        {
                                            (detail?.booking?.status === "Booked") ?
                                                <DropdownButton label="Edit" className="list-btns list-warning-btn" onClick={() => navigate(`/booking/update/${detail?.booking?.bookingId}`)} />
                                                : detail?.booking?.status === "Ongoing" ?
                                                    <DropdownButton label="Edit" className="list-btns list-warning-btn" onClick={() => navigate(`/booking/delivery/${detail?.booking?.bookingId}`)} />
                                                    : ""
                                        }
                                    </DropdownToggle>
                                </>
                        : <button className="btn btn-success btn-sm" onClick={() => navigate(`/booking/register`)}>Create Booking</button>
                }

            </div>
            <div className="justify-content-center align-items-stretch row">
                <div className="mt-4 mt-lg-0 col-sm-12 col-lg-5">
                    <div className="card h-100">
                        <div className="text-center fw-bold text-theme card-header cardHeading">
                            Form Info
                        </div>
                        <div className="text-center flex-column card-body">
                            <div className="row"> <div className="col">Form Number: {detail?.booking?.formNo || 0}</div> </div>
                            {detail?.booking?.formPhoto ? <div className="mt-2 d-flex justify-content-center row align-items-center">
                                <div md={3} className="m-0 col-md-3 text-center d-flex align-items-center justify-content-center">
                                    <button className="profile" style={{ 'minHeight': 'fit-content' }} onClick={() => { setForm(true) }}><img src={Profile} alt="Form" className="profilePhoto" /></button>
                                </div>
                            </div> : ""}
                        </div>
                    </div>
                </div>
                <div className="mt-4 mt-lg-0 col-lg-5">
                    <div className="card h-100">
                        <div className="text-center fw-bold text-theme card-header cardHeading">
                            Proof Collected
                        </div>
                        <div className="flex-column card-body">
                            <div className="row">
                                {
                                    proof && proof?.length > 0 ?
                                        proof?.map((element, i) => {
                                            return (
                                                <div className="headingCard text-uppercase col-12" key={i} id={i} sm={12}>
                                                    {element}
                                                </div>
                                            )
                                        })
                                        : <div className="headingCard text-center col"> No Proofs are collected</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-4 justify-content-center align-items-stretch row">
                <div className="col-lg-5">
                    <div className="card h-100">
                        <div className="text-center fw-bold text-theme card-header cardHeading">
                            Customer Info
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col"> <div className="card-title"> Cust ID </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.customerId || "-"} {detail?.customer?.status === "Verified" ? <i className="fa-solid fa-check-circle text-success"></i> : (detail?.customer?.status === "Unverified" ? <i className="fa-solid fa-circle-xmark text-danger"></i> : "")}</div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Name </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {(detail?.customer?.firstName || "-") + " " + (detail?.customer?.lastName || "")} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Primary Mobile </div> </div>
                                <div className="col"><div className="card-text">  {detail?.customer?.phone?.length ? (detail?.customer?.phone?.filter(element => element?.priority === 1)?.length ? ((detail?.customer?.phone?.filter(element => element?.priority === 1)[0]?.code || "") + "-" + (detail?.customer?.phone?.filter(element => element?.priority === 1)[0]?.phone || "")) : "-") : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title">Alternate Mobile </div> </div>
                                <div className="col"><div className="card-text">  {detail?.customer?.phone?.length ? (detail?.customer?.phone?.filter(element => element?.priority === 2)?.length ? ((detail?.customer?.phone?.filter(element => element?.priority === 2)[0]?.code || "") + "-" + (detail?.customer?.phone?.filter(element => element?.priority === 2)[0]?.phone || "")) : "-") : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Alternate 2 Mobile  </div> </div>
                                <div className="col"><div className="card-text">  {detail?.customer?.phone?.length ? (detail?.customer?.phone?.filter(element => element?.priority === 3)?.length ? ((detail?.customer?.phone?.filter(element => element?.priority === 3)[0]?.code || "") + "-" + (detail?.customer?.phone?.filter(element => element?.priority === 3)[0]?.phone || "")) : "-") : "-"} </div> </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-4 mt-lg-0 col-lg-5">
                    <div className="card h-100">
                        <div className="text-center fw-bold text-theme card-header cardHeading">
                            Vehicle Info
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col"> <div className="card-title">Car ID </div> </div>
                                <div className="col"><div className="card-text">  {detail?.car?.carId || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Model </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {detail?.car?.model || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Color </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {detail?.car?.color || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Reg No </div> </div>
                                <div className="col"><div className="card-text">  {detail?.car?.registrationNo || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Fastag Bank </div> </div>
                                <div className="col"><div className="card-text">  {detail?.car?.fasTagType || "-"} </div> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-4 justify-content-center row align-items-stretch">
                <div className="col-lg-5">
                    <div className="card h-100">
                        <div className="text-center fw-bold text-theme card-header cardHeading">
                            Trip Info
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col"> <div className="card-title"> Delivery Date and Time </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.deliveryDetails?.delivery ? moment(new Date(detail?.booking?.deliveryDetails?.delivery)).format("DD/MM/YYYY hh:mm A") : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Actual Pickup Date and Time (After) </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.pickupDetails?.pickup ? moment(new Date(detail?.booking?.pickupDetails?.pickup)).format("DD/MM/YYYY hh:mm A") : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Default Pickup Date and Time (Before) </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.pickupDetails?.default || detail?.booking?.pickupDetails?.pickup ? moment(new Date(detail?.booking?.pickupDetails?.default || detail?.booking?.pickupDetails?.pickup)).format("DD/MM/YYYY hh:mm A") : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Total Days </div> </div>
                                <div className="col"><div className="card-text">  {(totalDays + point?.value || 0)} {Number(totalDays + point?.value) > 1 ? " Days" : " Day"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Delivery Location </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {detail?.booking?.deliveryDetails?.location || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Pickup Location </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {detail?.booking?.pickupDetails?.location || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Package </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.package ? "P - " + detail?.booking?.package : "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Start KM </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.km?.start || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title">End KM </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.km?.end || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Start Fuel </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.fuel?.start || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title">End Fuel </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.fuel?.end || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Tag Open </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.fastTag?.start || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Tag Close</div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.fastTag?.end || "0"} </div> </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-4 mt-lg-0 col-lg-5">
                    <div className="card h-100">
                        <div className="text-center fw-bold text-theme card-header cardHeading">
                            Excess Usage Info
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col"> <div className="card-title">Used KM </div> </div>
                                <div className="col"><div className="card-text">  {detail?.status === "Completed" || detail?.status === "Pending" ? (Number(detail?.booking?.km?.end || 0) - Number(detail?.booking?.km?.start || 0)) : 0} </div> </div>
                            </div>
                            {
                                Number(detail?.booking?.excess?.kmDriven) > 0 ?
                                    <>
                                        <div className="row">
                                            <div className="col"> <div className="card-title"> Excess KM </div> </div>
                                            <div className="col"><div className="card-text">  {detail?.booking?.excess?.kmDriven || "0"} </div> </div>
                                        </div>
                                        <div className="row">
                                            <div className="col"> <div className="card-title"> KM Charges</div> </div>
                                            <div className="col"><div className="card-text">  {detail?.booking?.excess?.kmCharges || "0"} </div> </div>
                                        </div>
                                    </> : ""
                            }
                            <div className="row">
                                <div className="col"> <div className="card-title">Used Fuel </div> </div>
                                <div className="col"><div className="card-text">  {detail?.status === "Completed" || detail?.status === "Pending" ? (Number(detail?.booking?.fuel?.end) < Number(detail?.booking?.fuel?.start) ? (Number(detail?.booking?.fuel?.start) - Number(detail?.booking?.fuel?.end)) : 0) : 0} </div> </div>
                            </div>
                            {
                                Number(detail?.booking?.excess?.fuelConsumed) > 0 ?
                                    <>
                                        <div className="row">
                                            <div className="col"> <div className="card-title"> Fuel Consumed </div> </div>
                                            <div className="col"><div className="card-text">  {detail?.booking?.excess?.fuelConsumed || "0"} </div> </div>
                                        </div>
                                        <div className="row">
                                            <div className="col"> <div className="card-title"> Fuel Charges </div> </div>
                                            <div className="col"><div className="card-text">  {detail?.booking?.excess?.fuelCharges || "0"} </div> </div>
                                        </div>
                                    </> : ""
                            }
                            <div className="row">
                                <div className="col"> <div className="card-title">  {Number(detail?.booking?.fastTag?.start) > Number(detail?.booking?.fastTag?.end) ? "Tag Used Amt" : "Excess Tag Amt"}</div> </div>
                                <div className="col"><div className="card-text">  {detail?.status === "Completed" || detail?.status === "Pending" ? (Number(detail?.booking?.fastTag?.start) > Number(detail?.booking?.fastTag?.end) ? (Number(detail?.booking?.fastTag?.start) - Number(detail?.booking?.fastTag?.end)) : (Number(detail?.booking?.fastTag?.end) - Number(detail?.booking?.fastTag?.start))) : 0} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Hours Used </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.excess?.timeUsed || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Hour Charges </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.excess?.timeCharges || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Fine Charges </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.excessCharges?.length ? (detail?.booking?.excessCharges?.filter(element => element?.name === "fine")?.length ? detail?.booking?.excessCharges?.filter(element => element?.name === "fine")[0]?.amount : "-") : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Fine Remarks </div> </div>
                                <div className="col"><div className="text-capitalize card-text">  {detail?.booking?.excessCharges?.length ? (detail?.booking?.excessCharges?.filter(element => element?.name === "fine")?.length ? detail?.booking?.excessCharges?.filter(element => element?.name === "fine")[0]?.remarks : "-") : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title">Damage Charges</div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.excessCharges?.length ? (detail?.booking?.excessCharges?.filter(element => element?.name === "damage")?.length ? detail?.booking?.excessCharges?.filter(element => element?.name === "damage")[0]?.amount : "-") : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title">Damage Remarks</div> </div>
                                <div className="col"><div className="text-capitalize card-text">  {detail?.booking?.excessCharges?.length ? (detail?.booking?.excessCharges?.filter(element => element?.name === "damage")?.length ? detail?.booking?.excessCharges?.filter(element => element?.name === "damage")[0]?.remarks : "-") : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title">Other Charges </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.excessCharges?.length ? (detail?.booking?.excessCharges?.filter(element => element?.name === "other")?.length ? detail?.booking?.excessCharges?.filter(element => element?.name === "other")[0]?.amount : "-") : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Other Remarks </div> </div>
                                <div className="col"><div className="text-capitalize card-text">  {detail?.booking?.excessCharges?.length ? (detail?.booking?.excessCharges?.filter(element => element?.name === "other")?.length ? detail?.booking?.excessCharges?.filter(element => element?.name === "other")[0]?.remarks : "-") : "-"} </div> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-4 justify-content-center row align-items-stretch">
                <div className="mt-4 mt-lg-0 col-lg-5">
                    <div className="card h-100">
                        <div className="text-center fw-bold text-theme card-header cardHeading">
                            Payment Info
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col"> <div className="card-title"> Cost Per Day </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.rentalFee || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Offer Per Day </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.offerPerDay || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Total Days </div> </div>
                                <div className="col"><div className="card-text">  {(totalDays + point?.value || 0)} {Number(totalDays + point?.value) > 1 ? " Days" : " Day"} </div> </div>
                            </div>
                            {
                                point?.value === 0.5 ?
                                    <div className="row">
                                        <div className="col"> <div className="card-title"> Half Day Offer </div> </div>
                                        <div className="col"><div className="card-text">  {detail?.booking?.halfDayOffer || "0"} </div> </div>
                                    </div>
                                    : ""
                            }
                            <div className="row">
                                <div className="col"> <div className="card-title"> Total Rent </div> </div>
                                <div className="col"><div className="card-text">  {((Number(detail?.booking?.rentalFee) - Number(detail?.booking?.offerPerDay)) * Number((totalDays || 0))) + (point?.value === 0.5 ? ((Number(detail?.booking?.rentalFee) / 2) - Number(detail?.booking?.halfDayOffer)) : 0) || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Delivery Charge </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.deliveryDetails?.price || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Pickup Charge </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.pickupDetails?.price || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Security Deposit </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.securityDeposit || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Total Amt Collected </div> </div>
                                <div className="col"><div className="card-text">  {(((Number(detail?.booking?.rentalFee) - Number(detail?.booking?.offerPerDay)) * Number((totalDays || 0))) + (point?.value === 0.5 ? ((Number(detail?.booking?.rentalFee) / 2) - Number(detail?.booking?.halfDayOffer)) : 0) + Number(detail?.booking?.securityDeposit) + Number(detail?.booking?.deliveryDetails?.price) + Number(detail?.booking?.pickupDetails?.price)) || "0"} </div> </div>
                            </div>
                            {detail?.booking?.advance?.photo ?
                                <div className="row">
                                    <div className="text-center col">
                                        <div className="card-title"><button className="btn btn-sm btn-theme" onClick={() => setPhoto({ name: "Advance", photo: detail?.booking?.advance?.photo, open: true })}>Advance Photo</button></div>
                                    </div>
                                </div>
                                : ""}
                        </div>
                    </div>
                </div>
                <div sm={12} lg={5} className="mt-4 mt-lg-0 col-sm-12 col-lg-5">
                    <div className="p-0 card h-100">
                        <div className="text-center fw-bold text-theme card-header cardHeading">
                            Payment Info
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col"> <div className="card-title"> Advance Paid </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.advance?.amount || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Advance Paid Mode </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.advance?.mode || "0"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Advance Paid Remarks </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {detail?.booking?.advance?.remarks || "0"} </div> </div>
                            </div>
                            {
                                detail?.booking?.balance?.length
                                    ?
                                    detail?.booking?.balance?.map((element, i) => {
                                        return (
                                            <div key={i}>
                                                <div className="row">
                                                    <div className="col"> <div className="card-title">Balance {i + 1} </div> </div>
                                                    <div className="col">
                                                        <div className="card-text"> {Number(element?.amount)} </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col"> <div className="card-title"> Paid Mode </div> </div>
                                                    <div className="col"><div className="card-text">  {element?.mode || "-"} </div> </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col"> <div className="card-title"> Remarks </div> </div>
                                                    <div className="col"><div className="card-text text-capitalize">  {element?.remarks || "-"} </div> </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : ""
                            }
                            {
                                detail?.booking?.excessBalance?.length
                                    ?
                                    detail?.booking?.excessBalance?.map((element, i) => {
                                        return (
                                            <div key={i}>
                                                <div className="row">
                                                    <div className="col"> <div className="card-title">Excess Balance {i + 1} </div> </div>
                                                    <div className="col">
                                                        <div className="card-text"> {Number(element?.amount)} </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col"> <div className="card-title"> Paid Mode </div> </div>
                                                    <div className="col"><div className="card-text">  {element?.mode || "-"} </div> </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col"> <div className="card-title"> Remarks </div> </div>
                                                    <div className="col"><div className="card-text text-capitalize">  {element?.remarks || "-"} </div> </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : ""
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-4 justify-content-center align-items-stretch row">
                <div className="col-lg-5">
                    <div className="card h-100">
                        <div className="text-center fw-bold text-theme card-header cardHeading">
                            Booking Info
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col"> <div className="card-title"> Booked At </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.createdAt ? moment(new Date(detail?.booking?.createdAt)).format('DD/MM/YYYY') : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Lead Mode </div> </div>
                                <div className="col"><div className="card-text">  {detail?.booking?.lead?.mode || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Booking Taken By </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {(detail?.booking?.lead?.name) || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Delivery By </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {detail?.booking?.stageHistory?.length ? (detail?.booking?.stageHistory?.filter(element => element?.stage === "Ongoing")?.length ? (detail?.booking?.stageHistory?.filter(element => element?.stage === "Ongoing")[0]?.subadmin?.name || detail?.booking?.stageHistory?.filter(element => element?.stage === "Ongoing")[0]?.admin?.name) : "-") : "-"} </div> </div>
                            </div>
                            {detail?.pending_by ? <div className="row">
                                <div className="col"> <div className="card-title"> Pending By </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {detail?.booking?.stageHistory?.length ? (detail?.booking?.stageHistory?.filter(element => element?.stage === "Pending")?.length ? (detail?.booking?.stageHistory?.filter(element => element?.stage === "Pending")[0]?.subadmin?.name || detail?.booking?.stageHistory?.filter(element => element?.stage === "Pending")[0]?.admin?.name) : "-") : "-"} </div> </div>
                            </div> : ""}
                            <div className="row">
                                <div className="col"> <div className="card-title"> Pickup By </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {detail?.booking?.stageHistory?.length ? (detail?.booking?.stageHistory?.filter(element => element?.stage === "Completed")?.length ? (detail?.booking?.stageHistory?.filter(element => element?.stage === "Completed")[0]?.subadmin?.name || detail?.booking?.stageHistory?.filter(element => element?.stage === "Completed")[0]?.admin?.name) : "-") : "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title"> Comment </div> </div>
                                <div className="col"><div className="card-text text-capitalize">  {detail?.booking?.comment || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title">Customer Remarks</div> </div>
                                <div className="col"><div className="text-capitalize card-text">  {detail?.customer?.remarks || "-"} </div> </div>
                            </div>
                        </div>
                    </div>
                </div>
                {detail?.booking?.status === "Completed" ?
                    <div className="mt-4 mt-lg-0 col-lg-5">
                        <div className="card h-100">
                            <div className="text-center fw-bold text-theme card-header cardHeading">
                                Refund Info
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col"> <div className="card-title"> Total Cost </div> </div>
                                    <div className="col"><div className="card-text">  {(((Number(detail?.booking?.rentalFee || 0) - Number(detail?.booking?.offerPerDay || 0)) * Number(totalDays || 0)) + (point?.value === 0.5 ? ((Number(detail?.booking?.rentalFee || 0) / 2) - Number(detail?.booking?.halfDayOffer || 0)) : 0)) || "0"} </div> </div>
                                </div>
                                <div className="row">
                                    <div className="col"> <div className="card-title">D & P</div> </div>
                                    <div className="col"><div className="card-text">  {Number(detail?.booking?.deliveryDetails?.price || 0) + Number(detail?.booking?.pickupDetails?.price || 0) || "0"} </div> </div>
                                </div>
                                <div className="row">
                                    <div className="col"> <div className="card-title"> Excess Usage </div> </div>
                                    <div className="col"><div className="card-text">  {(Number(detail?.booking?.excess?.fuelCharges || 0) + Number(detail?.booking?.excess?.kmCharges || 0) + Number(detail?.booking?.excess?.timeCharges || 0) + Number(((Number(detail?.booking?.fastTag?.start || 0) - Number(detail?.booking?.fastTag?.end || 0)) >= 0) ? (Number(detail?.booking?.fastTag?.start || 0) - Number(detail?.booking?.fastTag?.end || 0)) : 0)) || 0} </div> </div>
                                </div>
                                <div className="row">
                                    <div className="col"> <div className="card-title"> Other Charges </div> </div>
                                    <div className="col"><div className="card-text">  {(Number(detail?.booking?.excessCharges?.length ? detail?.booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount), 0) : 0)) || "0"} </div> </div>
                                </div>
                                <div className="row">
                                    <div className="col"> <div className="card-title"> Total Amt Collected </div> </div>
                                    <div className="col"><div className="card-text">  {Number(detail?.booking?.totalCostCollected || 0) - Number(detail?.booking?.refund?.offer || 0)} </div> </div>
                                </div>
                                <div className="row">
                                    <div className="col"> <div className="card-title"> Refund Amt </div> </div>
                                    <div className="col"><div className="card-text">  {refund || "0"} </div> </div>
                                </div>
                                {
                                    refund ?
                                        <>
                                            <div className="row">
                                                <div className="col"> <div className="card-title"> Refund Mode </div> </div>
                                                <div className="col"><div className="card-text">  {detail?.booking?.refund?.mode || "0"} </div> </div>
                                            </div>

                                            <div className="row">
                                                <div className="col"> <div className="card-title"> Refund Remarks </div> </div>
                                                <div className="col"><div className="card-text">  {detail?.booking?.refund?.remarks || "0"} </div> </div>
                                            </div>

                                            {
                                                detail?.booking?.refund?.at ?
                                                    <div className="row">
                                                        <div className="col"> <div className="card-title"> Refund At </div> </div>
                                                        <div className="col"><div className="card-text">  {moment(new Date(detail?.booking?.refund?.at)).format("DD/MM/YYYY hh:mm A")} </div> </div>
                                                    </div>
                                                    : ""
                                            }
                                        </>
                                        : ""
                                }
                            </div>
                        </div>
                    </div> : detail?.booking?.status === "Cancelled" ?
                        <div className="mt-4 mt-lg-0 col-lg-5">
                            <div className="card h-100">
                                <div className="text-center fw-bold text-theme card-header cardHeading">
                                    Cancelled Info
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col"> <div className="card-title"> Reason </div> </div>
                                        <div className="col"><div className="text-capitalize card-text"> {detail?.booking?.remarks || "-"} </div> </div>
                                    </div>
                                    <div className="row">
                                        <div className="col"> <div className="card-title"> Cancelled By </div> </div>
                                        <div className="col"><div className="card-text"> {detail?.booking?.stageHistory?.length ? (detail?.booking?.stageHistory?.filter(element => element?.stage === "Cancelled")?.length ? (detail?.booking?.stageHistory?.filter(element => element?.stage === "Cancelled")[0]?.subadmin?.name || detail?.booking?.stageHistory?.filter(element => element?.stage === "Cancelled")[0]?.admin?.name) : "-") : "-"} </div> </div>
                                    </div>
                                </div>
                            </div>
                        </div> : ""}
            </div>
            <div className="mt-4 mb-3 justify-content-center align-items-center row">
                {
                    detail?.booking?.pendingPhoto?.length ?
                        <div className="col-lg-5 text-center">
                            <div className="card">
                                <div className="text-center fw-bold text-theme card-header cardHeading">
                                    Pending Info
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col"> <div className="card-title"> Pending Remarks </div> </div>
                                        <div className="col"><div className="text-capitalize card-text">  {detail?.booking?.remarks || "-"} </div> </div>
                                    </div>
                                    <div className="row">
                                        <div className="col"> <div className="card-title"><button className="btn btn-sm btn-theme" onClick={() => handlePendingPhotos()}>Pending Photos</button></div> </div>
                                    </div>
                                </div>
                            </div>

                        </div> : ""
                }
                {(detail?.status === "Completed" && (Number(detail?.booking?.refundHold?.hold1 || 0) || Number(detail?.booking?.refund?.offer || 0))) ?
                    <div className="mt-4 mt-lg-0 col-lg-5">
                        <div className="card">
                            <div className="text-center fw-bold text-theme card-header cardHeading"> Refund Offer Info </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col"> <div className="card-title"> Refund Hold </div> </div>
                                    <div className="col"><div className="card-text">  {detail?.booking?.refundHold?.hold1 || "0"} </div> </div>
                                </div>
                                <div className="row">
                                    <div className="col"> <div className="card-title"> Refund Hold Remarks </div> </div>
                                    <div className="col"><div className=" text-capitalize card-text">  {detail?.booking?.refundHold?.remarks || "0"} </div>  </div>
                                </div>
                                <div className="row">
                                    <div className="col"> <div className="card-title"> Refund Offer Charges </div> </div>
                                    <div className="col"><div className="card-text">  {detail?.booking?.refund?.offer || "0"} </div> </div>
                                </div>
                                <div className="row">
                                    <div className="col"> <div className="card-title">Redund Offer Remarks</div> </div>
                                    <div className="col"><div className="text-capitalize card-text">  {detail?.booking?.refund?.offerRemarks || "-"} </div> </div>
                                </div>
                                {Number(detail?.booking?.refund?.offer) > 0 ?
                                    <>
                                        <div className="row">
                                            <div className="col"> <div className="card-title"> Actual Bill Amt </div> </div>
                                            <div className="col"><div className="card-text"> {detail?.booking?.totalCostCollected || "0"} </div> </div>
                                        </div>
                                        <div className="row">
                                            <div className="col"> <div className="card-title"> Final Bill Amt </div> </div>
                                            <div className="col"><div className="card-text">   {(Number(detail?.booking?.totalCostCollected || 0) - Number(detail?.booking?.refund?.offer || 0)) > 0 ? (Number(detail?.booking?.totalCostCollected || 0) - Number(detail?.booking?.refund?.offer || 0)) : Number(detail?.booking?.totalCostCollected || 0)} </div> </div>
                                        </div>
                                    </> : ""}
                            </div>
                        </div>
                    </div> : ""}
            </div>
            <div className="my-3 justify-content-center row">
                <div className="row justify-content-center gap-3">
                    {
                        detail?.stageHistory?.length ?
                            detail?.stageHistory?.map((element, i) => {
                                return (
                                    <div key={i} className="mb-3 mb-lg-0 col-md-6 col-xl-4">
                                        <div className="h-100 card">
                                            <div className="text-center card-header fw-bold cardHeading text-theme text-capitalize">
                                                {element?.stage} Stage
                                            </div>
                                            <div className="card-body d-flex flex-column justify-content-between">
                                                <div className="row">
                                                    <div className="col"> <div className="card-title headingCard"> Staff ID </div> </div>
                                                    <div className="col"><div className="card-text text-capitalize"> {element?.subadmin?.name || element?.admin?.name || element?.staffId} </div> </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col"> <div className="card-title headingCard">  Time </div> </div>
                                                    <div className="col"><div className="card-text"> {element?.at ? moment(new Date(element?.at))?.format('DD/MM/YYYY hh:mm A') : "-"} </div> </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            : ""
                    }
                </div>
            </div>
            {
                person === "admin" ? <div className="row  justify-content-center align-items-center"><div className="col-md-10"> <Log userLog={logDetails} loading={loading} pageNo={pageNo} next={next} onPageChange={setPageNo} count={count} onCountChange={setCount} /></div></div> : ""
            }
            <Modal header="Pending Photo" onShow={pending} toggle={() => setPending(false)} overlayToggle={() => setPending(false)}>
                <div className="d-flex flex-column align-items-center">
                    {
                        pending_photo?.length > 0 ?
                            pending_photo?.map((element) => {
                                return <div className="my-3"><img src={element} alt="Pending" className="pendingImage" /></div>
                            })
                            : <label> No Photos Available </label>
                    }</div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-sm btn-danger" onClick={() => setPending(false)}>Cancel</button>
                </div>
            </Modal>
            <Modal header={`${photo?.name} Photo`} size={"lg"} onShow={photo?.open} toggle={() => setPhoto((prev) => ({ ...prev, open: false }))} overlayToggle={() => setPhoto((prev) => ({ ...prev, open: false }))}>
                <div className="d-flex flex-column align-items-center">
                    <div className="my-3 w-100"><img src={photo?.photo} alt="Form" className="w-100" /></div>
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-sm btn-danger" onClick={() => setPhoto((prev) => ({ ...prev, open: false }))}>Cancel</button>
                </div>
            </Modal>
            <Modal header={`Form Photo`} size={"lg"} onShow={form} toggle={() => setForm(false)} overlayToggle={() => setForm(false)}>
                {/* <div className="form-check form-switch">
                    <label className="form-check-label" htmlFor="switchCheckChecked">Full Screen</label>
                    <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => setFullScreen(e.target.checked)} id="switchCheckChecked" checked={fullScreen} />
                </div> */}
                {person === "admin" ? <div className="align-items-center justify-content-end d-flex gap-2">
                    <input type="file" accept="image/*" className="d-none" name="advPhoto" disabled={loading} id="advPhoto" onChange={(e) => { handleImage(e) }} />
                    {loading ? "" : <label htmlFor="advPhoto" className="me-2 upload-btn">Upload</label>}
                    {loading ? "" : <i className="fa-solid fa-download fs-5 cursor-pointer" onClick={handleDownload}></i>}
                </div> : ""}
                <div className="d-flex flex-column align-items-center">
                    <div className="my-3 w-100"><img src={detail?.booking?.formPhoto} alt="Form" className="w-100" /></div>
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-sm btn-danger" onClick={() => setForm(false)}>Cancel</button>
                </div>
            </Modal>
            <Modal header="Change Vehicle" onShow={vehicle?.open} toggle={() => setVehicle((prev) => ({ ...prev, open: false }))} overlayToggle={() => setVehicle((prev) => ({ ...prev, open: false }))}>
                <div className="min-select">
                    <Select styles={{
                        control: (base, state) => ({
                            ...base,
                            borderColor: state.isFocused ? "#f16436" : base.borderColor,
                            boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                            "&:hover": {
                                borderColor: "#f16436"
                            }
                        }),
                        option: (style, state) => ({
                            ...style,
                            backgroundColor: state.isSelected
                                ? "#f16436"
                                : (state.isFocused || state.isActive)
                                    ? "#f164361a"
                                    : "white",
                            color: state.isSelected ? "white" : "black"
                        })
                    }}
                        isDisabled={loading} onChange={(e) => setVehicle((prev) => ({ ...prev, carId: e.value, value: e }))} value={vehicle?.value || ""} options={vehicle?.options} />
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button disabled={loading} className="btn btn-sm btn-success" onClick={() => { changeCar() }}>Change</button>
                </div>
            </Modal>
            <Modal header="Change Status" onShow={status?.open} toggle={() => setStatus((prev) => ({ ...prev, open: false }))} overlayToggle={() => setStatus((prev) => ({ ...prev, open: false }))}>
                <div className="min-select">
                    <Select styles={{
                        control: (base, state) => ({
                            ...base,
                            borderColor: state.isFocused ? "#f16436" : base.borderColor,
                            boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                            "&:hover": {
                                borderColor: "#f16436"
                            }
                        }),
                        option: (style, state) => ({
                            ...style,
                            backgroundColor: state.isSelected
                                ? "#f16436"
                                : (state.isFocused || state.isActive)
                                    ? "#f164361a"
                                    : "white",
                            color: state.isSelected ? "white" : "black"
                        })
                    }}
                        isDisabled={loading} onChange={(e) => setStatus((prev) => ({ ...prev, status: e.value }))} value={status?.status ? { label: status?.status, value: status?.status } : ""} options={status?.options} />
                </div>
                <div className="pt-4 pb-2 text-center"><button disabled={loading} className="btn btn-sm btn-success" onClick={() => { changeStatus() }}>Change</button>
                </div>
            </Modal>
            <Modal header={"Cancel Booking"} onShow={modal} toggle={() => showModal(false)} overlayToggle={() => showModal(false)}>
                Do you really wanna cancel the booking : {cancel?.booking}?
                <input placeholder="Remarks" autoComplete="off" className="form-control input-theme text-uppercase mt-3" onChange={(e) => setCancel((prev) => ({ ...prev, remarks: e.target.value }))} />
                <div className="pt-4 pb-2 text-center">
                    <button disabled={loading} className="btn btn-sm btn-danger" onClick={cancelBooking}>Cancel Booking</button>
                </div>
            </Modal>
        </React.Fragment >
    )
}

export default View;